// @flow
import React from 'react';
import { getFilesFromDropEvent } from '../util/DndUtil';
import { canUseModernUploader, getFileNodesFromDropEvent } from '../util/DndUtilModern';
import uploadAssets from '../upload/uploadAssets';
import Store from '../store/Store';
import { SHOW_UPLOADS } from '../store/Constants';
import t from '../i18n/I18n';

import './HomeTabUpload.css';
import System from "../basic/System";

const debug = require('../debug/debug')('wc:dnd:HomeTabUpload');

type Props = {
  ui: any
};

type State = {
  isOver: boolean
};

export default class HomeTabUpload extends React.Component<Props, State> {
  state = {
    isOver: false
  };

  onChange = async (e) => {
    debug('[onChange()] event: ', e);

    const isModern = canUseModernUploader(e);
    const files = isModern ? await getFileNodesFromDropEvent(e) : await getFilesFromDropEvent(e);
    this.setState({ isOver: false });
    if (!files.length) {
      debug('[onChange()] no files. return');
      console.log("Retuirning from on change ");
      return;
    }

    console.log(files);

    uploadAssets(files, { isModernUpload: isModern, uploadPath: '', projectName: '' });
    if (!System.isDesktop()) {
      Store.put(SHOW_UPLOADS, true);
    }
  };

  onClick = (event) => {
    event.target.value = null;
    this._input.click();
  };

  render() {
    return (
      <div
        name="HomeTabUpload"
        onDragEnter={() => this.setState({ isOver: true })}
        onDragLeave={() => this.setState({ isOver: false })}
        onDrop={this.onChange}
        onClick={this.onClick}
        style={{ backgroundColor: this.state.isOver ? 'rgba(235, 106, 92, 0.1)' : '' }}>
        {this.props.ui || <div className="pseudo-button">{t('SHARE_FILE')}</div>}
        <input
          ref={(node) => (this._input = node)}
          accept="*\*"
          type="file"
          style={{ position: 'fixed', top: '-1000px' }}
          onChange={this.onChange}
          multiple
        />
      </div>
    );
  }
}
